import { DatePipe } from '@angular/common';
import { TranslatePipe } from '../../filters/translate.pipe';
import { ItemStatusComponent } from '../../components/item-status/item-status.component';
import { AvatarComponent } from '../../components/avatar/avatar.component';
import { ItemRatingComponent } from '../../components/item-rating/item-rating.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import Config from '../../utils/config.service';
import ChatRestServices from '../../services/chat-rest.service';
import ChatService from '../../services/chat.service';
import DialogServices from '../../services/dialog.service';
import ServiceRestServices from '../../services/service-rest.service';
import CategoryService from '../../services/category.service';
import Toast from '../../services/toast.service';
import UserService from '../../services/user.service';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';
import moment from 'moment';
import { Input } from '@angular/core';

@Component({
	standalone: true,
	selector: 'card-appointment',
	templateUrl: './card-appointment.component.html',
	imports: [ CommonModule, DatePipe, TranslatePipe, ItemStatusComponent, AvatarComponent, ItemRatingComponent, FormsModule ]
})
export class CardAppointmentComponent implements OnInit {
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private config: Config = inject(Config);
	private chatRestServices: ChatRestServices = inject(ChatRestServices);
	private chatService: ChatService = inject(ChatService);
	private dialogServices: DialogServices = inject(DialogServices);
	private serviceRestServices: ServiceRestServices = inject(ServiceRestServices);
	private categoryService: CategoryService = inject(CategoryService);
	private toast: Toast = inject(Toast);
	private userService: UserService = inject(UserService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	
	@Input() appointment: any | undefined;
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		var params = {
			subcategory: this.vm.appointment.service.subcategory,
			furtherSubcategory: this.vm.appointment.service.furtherSubcategory
		};
		this.categoryService.getTranslation(params).then((category) => {
			this.vm.category = category;
			this.initialize();
		});
		
		this.vm.openChat = this.openChat;
		this.vm.cancel = this.cancel;
		this.vm.isCancelAllowed = this.isCancelAllowed;
	}
	
	initialize() {
		var d: any = moment(this.vm.appointment.scheduledStart).calendar().split(' ')[0];
		this.vm.appointment.startDate = (d === 'Today' || d === 'Tomorrow')
			? this.angularFilterHelperService.translate('Services.Time.' + d)
			: this.angularFilterHelperService.formatDate(this.vm.appointment.scheduledStart, 'dd.MM.yy');
		this.vm.appointment.service = this.vm.appointment.service || {};
		this.vm.appointment.service.occupation = this.vm.category;
		this.vm.appointment.service.license = (this.vm.appointment.service.licenseNumber)
			? this.angularFilterHelperService.translate('Subscription.Label.LicenseNumber') + ': ' + this.vm.appointment.service.licenseNumber
			: '';
	}
	
	openChat() {
		if (this.vm.appointment.status !== 'CONFIRMED') {
			this.toast.showAsync(this.angularFilterHelperService.translate('Chats.Notifications.Opening_Not_Confirmed'),
				this.angularFilterHelperService.translate('Common.Got_It'));
			return;
		}
		this.chatRestServices.getChatByFriendId({ friendUserId: this.vm.appointment.service.user.id }, (chat) => {
			this.chatService.openChatById(this.vm.appointment.service.user, chat.id);
		});
	}
	
	isCancelAllowed() {
		return (moment(this.vm.appointment.scheduledStart).diff(moment(), 'hours', true) >= 24);
	}
	
	cancel() {
		if (!this.vm.isCancelAllowed) return;
		var dialog = this.dialogServices.confirmation({
			title: this.angularFilterHelperService.translate('Modal.Title.Confirm'),
			content: this.angularFilterHelperService.translate('Services.Other.Confirm_Cancel'),
		});
		dialog.afterClosed().subscribe((data) => {
			if (data) {
				this.serviceRestServices.declineBookingForBU({ id: this.vm.appointment.id }, () => {
					this.userService.clearWalletCache();
					this.angularBroadcastHelperService.rootBroadcast(
						this.config.getBroadcastConfig().Services.BOOKING_CANCELLED,
						{ id: this.vm.appointment.id }
					);
				});
			}
		});
	}
	
}